import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-why-huiospay',
  templateUrl: './new-why-huiospay.component.html',
  styleUrls: ['./new-why-huiospay.component.scss']
})
export class NewWhyHuiospayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
